var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { refreshToken } from '../containers/pages/OnBoarding/Login/LoginService';
import { Constants } from './Constants';
const BASE_URL = Constants.REACT_APP_API_BASE_URL_ONBOARDING; // base url
const AUTH_TOKEN_KEY = 'accessToken'; // token key
const axiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'x-api-version': 1
    },
    // withCredentials: true, // Include credentials such as cookies in the request
});
const formAxiosInstance = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'multipart/form-data',
    },
    // withCredentials: true, // Include credentials such as cookies in the request
});
// const ratesAxiosInstance: AxiosInstance = axios.create({
//     baseURL: "https://api-in.dev.zippyy.ai",
//     headers: {
//         'Content-Type': 'application/json',
//         'Accept': '*/*',
//         'x-api-version': 1
//     }
// })
export const isTokenExpired = (accessToken) => {
    if (!accessToken) {
        // Token is missing or invalid
        return true;
    }
    // Decode the JWT token payload
    const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
    // Get the expiration time from the token payload
    const expirationTime = tokenPayload.exp;
    // Convert the expiration time to milliseconds
    const now = Date.now() / 1000; // Current time in seconds
    console.log(now, expirationTime);
    // Check if the token has expired
    return expirationTime < now;
};
formAxiosInstance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    const authToken = localStorage.getItem("accessToken");
    if (authToken) {
        // Check if the access token has expired
        if (isTokenExpired(authToken)) {
            try {
                // Attempt to refresh the token
                const refreshedToken = yield refreshToken();
                // Update the authorization header with the new token
                config.headers['Authorization'] = `Bearer ${refreshedToken}`;
            }
            catch (error) {
                // Handle token refresh error
                console.error('Error refreshing token:', error);
                // Optionally, redirect the user to the login page or perform other actions
            }
        }
        else {
            // Token is still valid, include it in the request header
            config.headers['Authorization'] = `Bearer ${authToken}`;
        }
    }
    return config;
}), (error) => {
    // Handle request error
    return Promise.reject(error);
});
axiosInstance.interceptors.request.use((config) => __awaiter(void 0, void 0, void 0, function* () {
    const authToken = localStorage.getItem("accessToken");
    if (authToken) {
        // Check if the access token has expired
        if (isTokenExpired(authToken)) {
            try {
                // Attempt to refresh the token
                const refreshedToken = yield refreshToken();
                // Update the authorization header with the new token
                console.log("refreshed token");
                config.headers['Authorization'] = `Bearer ${refreshedToken}`;
            }
            catch (error) {
                // Handle token refresh error
                console.error('Error refreshing token:', error);
                // Optionally, redirect the user to the login page or perform other actions
            }
        }
        else {
            // Token is still valid, include it in the request header
            console.log("token still valid");
            config.headers['Authorization'] = `Bearer ${authToken}`;
        }
    }
    return config;
}), (error) => {
    // Handle request error
    return Promise.reject(error);
});
// ratesAxiosInstance.interceptors.request.use(async (config) => {
//     const authToken = localStorage.getItem("accessToken");
//     if (authToken) {
//         // Check if the access token has expired
//         if (isTokenExpired(authToken)) {
//             try {
//                 // Attempt to refresh the token
//                 const refreshedToken = await refreshToken();
//                 // Update the authorization header with the new token
//                 config.headers['Authorization'] = `Bearer ${refreshedToken}`;
//             } catch (error) {
//                 // Handle token refresh error
//                 console.error('Error refreshing token:', error);
//                 // Optionally, redirect the user to the login page or perform other actions
//             }
//         } else {
//             // Token is still valid, include it in the request header
//             config.headers['Authorization'] = `Bearer ${authToken}`;
//         }
//     }
//     return config;
// }, (error) => {
//     // Handle request error
//     return Promise.reject(error);
// });
const api = {
    formUpload: (endpoint, payload) => formAxiosInstance.post(endpoint, payload).then((response) => response.data),
    get: (endpoint, payload) => axiosInstance.get(endpoint, { params: payload }).then((response) => response.data),
    post: (endpoint, payload) => axiosInstance.post(endpoint, payload).then((response) => response.data),
    put: (endpoint, payload) => axiosInstance.put(endpoint, payload).then((response) => response.data),
    delete: (endpoint) => axiosInstance.delete(endpoint).then((response) => response.data),
    //postrate: <T>(endpoint: string, payload: any): Promise<T> => ratesAxiosInstance.post<any>(endpoint, payload).then((response: any) => response.data)
};
export default api;
